import type { Account } from '@/api/types'
import { TenantRow } from './TenantRow'

/**
 * The workspace picker: one tenant per line, full column width.
 *
 * A list rather than a grid — the column is scanned top-to-bottom like
 * everything else on the page, and a long workspace name gets the whole
 * width to ellipsis into instead of a grid cell's third.
 */
export function TenantList({ accounts }: { accounts: Account[] }) {
  return (
    <ul className="wslist">
      {accounts.map((account) => (
        <li key={account.subdomain}>
          <TenantRow account={account} />
        </li>
      ))}
    </ul>
  )
}
